import * as React from 'react';
import { Label, UIHeading2, UIText1 } from '@cian/ui-kit';
import { formatDiscount, formatMoney } from '../../../../../../utils/string';
import * as styles from './Price.css';

interface IProps {
  marketingPrice: number | null;
  discountPercent: number | null;
  total: number;
}

export const Price = ({ marketingPrice, discountPercent, total }: IProps) => {
  return (
    <div className={styles['root']}>
      <div className={styles['price']}>
        {marketingPrice && (
          <UIText1 color="gray60_100" display="inline">
            <span className={styles['marketing-price']}>{formatMoney(marketingPrice)}</span>
          </UIText1>
        )}
        {discountPercent && (
          <Label background="error_10" color="error_100">
            {formatDiscount(discountPercent)}
          </Label>
        )}
      </div>
      <div className={styles['total']}>
        <UIHeading2>К оплате</UIHeading2>
        <UIHeading2>{formatMoney(total)}</UIHeading2>
      </div>
    </div>
  );
};
